import { render, staticRenderFns } from "./NavigationPanel.vue?vue&type=template&id=1353a3cc"
import script from "./NavigationPanel.vue?vue&type=script&lang=ts"
export * from "./NavigationPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports